import { Component, OnInit, Inject } from '@angular/core';
import { RemoteService } from 'app/services/remote.service';
import { LocalStorageService } from 'ngx-store';
import { NotifierService } from 'angular-notifier';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-cash-withdraw-deposit',
  templateUrl: './cash-withdraw-deposit.component.html',
  styleUrls: ['./cash-withdraw-deposit.component.scss']
})
export class CashWithdrawDepositComponent implements OnInit {
  requestCash: FormGroup;
  formSumitAttempt: boolean;
  moneyData: any;
  displayObject = {
    title: 'Deposit Details',
    lable: 'Deposit Money',
    buttonName: 'Deposit',
    dateLabel: 'Deposit Date',
    currencyLabel: 'Currency',
    currencies: ['CAD', 'USD']
  };
  constructor(public dialogRef: MatDialogRef<CashWithdrawDepositComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmUserDialogModel,
    private fb: FormBuilder,
    private notifierService: NotifierService,
    public ls: LocalStorageService,
    private remoteService: RemoteService,
    private datePipe: DatePipe) {
    this.moneyData = data
  }

  ngOnInit() {
    try {
      //@ts-ignore
      $('.datepicker').datepicker({ maxDate: new Date() });
    } catch (e) { }
    this.requestCash = this.fb.group({
      requestMoney: ['', Validators.required],
      comments: [''],
      tradeDate: ['', Validators.required],
      currency: ['', Validators.required]
    })
    if (this.moneyData.name === 'deposit') {
      this.displayObject = {
        title: 'Deposit Details',
        lable: 'Deposit Money',
        buttonName: 'Deposit',
        dateLabel: 'Deposit Date',
        currencyLabel: 'Currency',
        currencies: ['CAD', 'USD']
      }
    } else {
      this.displayObject = {
        title: 'Withdraw Details',
        lable: 'Withdraw Money',
        buttonName: 'Withdraw',
        dateLabel: 'Withdraw Date',
        currencyLabel: 'Currency',
        currencies: ['CAD', 'USD']
      }
    }
  }

  isFieldValid(field: string) {
    return (
      (!this.requestCash.get(field).valid && this.requestCash.get(field).touched) ||
      (this.requestCash.get(field).untouched && this.formSumitAttempt)
    );
  }

  selectedTradeDate(date) {
    this.requestCash.patchValue({ tradeDate: this.datePipe.transform(date, 'mediumDate') });
  }

  onConfirm(): void {
    if (this.requestCash.valid) {
      if (this.moneyData.name === 'deposit') {
        const payload = {
          "amount": this.requestCash.value.requestMoney,
          portfolioId: this.ls.get('editPortfolioId'),
          transactionDate: this.datePipe.transform(this.requestCash.value.tradeDate, 'yyyy-MM-dd'),
          comments:this.requestCash.value.comments,
          currency: this.requestCash.value.currency
        }
        this.remoteService.portfolioDeposit(payload).subscribe(() => {
          this.dialogRef.close(true);
          this.notifierService.notify('success', 'Cash deposited successfully.');
          this.investorDetailsgetByUsingEmailId();
        }, error => {
          this.remoteService.errorFunction(error);
        })
      } else {
        if (this.moneyData.portfolioRemainingCash < this.requestCash.value.requestMoney) {
          return this.notifierService.notify('error', 'The amount is not sufficient to withdrew.');
        }
        const payload = {
          "amount": this.requestCash.value.requestMoney,
          portfolioId: this.ls.get('editPortfolioId'),
          transactionDate: this.datePipe.transform(this.requestCash.value.tradeDate, 'yyyy-MM-dd'),
          comments:this.requestCash.value.comments,
          currency: this.requestCash.value.currency
        }
        this.remoteService.portfolioWithdraw(payload).subscribe(() => {
          this.dialogRef.close(true);
          this.notifierService.notify('success', 'Cash withdrew successfully.');
          this.investorDetailsgetByUsingEmailId();
        }, error => {
          this.remoteService.errorFunction(error);
        })
      }
    } else {
      this.notifierService.notify('error', 'Invalid Inputs');
    }
  }

  investorDetailsgetByUsingEmailId() {
    this.remoteService.getInvestorDetailsByUsingEmail(this.ls.get('userName'), (res) => {
      this.ls.set('investorDetails', JSON.parse(res));
    }, (error) => {
      this.remoteService.errorFunction(error);
    });
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}

export class ConfirmUserDialogModel {
  constructor(public dialogData: object) { }
}